import Vue from 'vue';

const files = require.context('./', true, /\.vue$/);
const prefix = 'cp-';
const ignore = ['/structure', '/support'];

files.keys().forEach((key) => {
    for (const test of ignore) {
        if (key.includes(test)) return
    }

    const name = prefix + _.kebabCase(key.replace(/.*\/|\..*$/g, ''));
    Vue.component(name, files(key).default);
});
